<p-dialog
  header="{{ 'OPMONITORING.SCREEN.NOTIFICATION_LIMIT_INFO' | translate }}"
  [modal]="true"
  [(visible)]="isVisible"
  (onHide)="onDialogHide($event)"
  [dismissableMask]="true"
>
  <app-progress-spinner [enabled]="saving || loading" />
  @if (!saving && !loading) {
    <div class="container">
      <form [formGroup]="alarmLimitForm">
        <div id="alarm-limit-form">
          @if (formType() === 'Edit') {
            <div class="actions-dropdown">
              <label class="label" [style]="{ 'text-align': 'center' }"
                >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</label
              >
              <span class="no-padding-top-bottom">
                <p-select
                  [options]="availableActions"
                  (onChange)="onActionSelected($event)"
                  [(ngModel)]="selectedAction"
                  [ngModelOptions]="{ standalone: true }"
                  appendTo="body"
                  styleClass="action-drop-down"
                />
              </span>
            </div>
          }
          <div>
            <label>{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label>
            <div>
              <p-select
                [options]="facilities"
                formControlName="facility"
                styleClass="w-100"
                optionLabel="facilityName"
                placeholder="{{
                  'CRM.MESSAGES.PLACEHOLDER.FACILITY' | translate
                }}"
                [virtualScroll]="true"
                [filter]="true"
                [virtualScrollItemSize]="30"
                (onChange)="onFacilityChanged($event)"
              />
            </div>
          </div>
          <div>
            <label
              >{{ 'OPMONITORING.LABEL.ASSET_IDENTIFIER' | translate }}:</label
            >
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="assetIdentifier"
              />
            </div>
          </div>
          <div>
            <label
              >{{
                'OPMONITORING.LABEL.LIMIT_ATTRIBUTE_NAME' | translate
              }}:</label
            >
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="alarmAttributeName"
              />
            </div>
          </div>
          <div>
            <label>{{ 'OPMONITORING.LABEL.DATATYPE' | translate }}:</label>
            <div>
              <p-select
                [options]="datatypes"
                formControlName="datatype"
                placeholder="{{ 'OPMONITORING.MESSAGES.PLACEHOLDER.DATATYPE' }}"
                styleClass="w-100"
              />
            </div>
          </div>
          <div>
            <label>{{ 'OPMONITORING.LABEL.LIMIT_VALUE' | translate }}:</label>
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="limitValue"
              />
            </div>
          </div>
          <div>
            <label
              >{{
                'OPMONITORING.LABEL.EFFECTIVE_DATE_TIME' | translate
              }}:</label
            >
            <p-datepicker
              formControlName="effectiveDateTime"
              [showTime]="true"
              hourFormat="24"
              [minDate]="minDateTime"
              appendTo="body"
            />
          </div>
          <div>
            <label>{{ 'COMMON.LABEL.UPDATER' | translate }}:</label>
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="updater"
              />
            </div>
          </div>
          <div>
            <label>{{ 'OPMONITORING.LABEL.UPDATED_AT' | translate }}:</label>
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="updatedAt"
              />
            </div>
          </div>
          <div>
            <label>{{ 'OPMONITORING.LABEL.UPDATE_REASON' | translate }}:</label>
            <div>
              <input
                class="dialog-input"
                type="text"
                pInputText
                formControlName="updateReason"
              />
            </div>
          </div>
          <div class="button">
            <button
              pButton
              pRipple
              label="Save"
              class="p-button-raised p-button-success right-align"
              [disabled]="!alarmLimitForm.valid"
              (click)="onSubmit()"
              type="button"
            ></button>
          </div>
        </div>
      </form>
    </div>
  }
</p-dialog>

<app-alarm-limit-audit-trail
  [isVisible]="auditTrailVisible"
  (dialogHidden)="onAuditTrailHidden()"
  [selectedAlarmLimit]="selectedAlarmLimit()"
  #alarmLimitAuditTrail
/>
